import Orders from "./VendorPayoutsDetailTabs/Orders";
import { Card, Typography, Button, Tabs, Modal } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import { capitalizeName, formatDateFunction } from "../../../utils/helper/utils";
import SettlePayout from "../../../Modal/SettlePayout";
import { checkPermissionAction } from "../../../utils/helper/utils";
import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import { saveAs } from "file-saver";

/**
 * Opens a small popup window and resolves once it posts back a
 * { source: "quickbooks-oauth", status: "success" | "error", ... } message
 * (sent by the backend's /v1/quickbooks/callback page), or rejects if the
 * user closes the popup before finishing.
 */
const waitForQuickBooksPopupResult = (popup) => {
  return new Promise((resolve, reject) => {
    const handleMessage = (event) => {
      const data = event.data;
      if (!data) return;

      window.removeEventListener("message", handleMessage);
      clearInterval(popupClosedCheck);

      if (data.status === "success") {
        resolve(data);
      } else {
        reject(new Error(data.message));
      }
    };

    window.addEventListener("message", handleMessage);

    // Safety net: if the user closes the popup manually without connecting.
    const popupClosedCheck = setInterval(() => {
      if (popup.closed) {
        clearInterval(popupClosedCheck);
        setTimeout(() => {
          window.removeEventListener("message", handleMessage);
          reject(new Error("QuickBooks connection window was closed before completing."));
        }, 300);
      }
    }, 500);
  });
};

const VendorPayoutsDetail = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [payoutData, setPayoutData] = useState([]);
  const [isSettlePayoutModel, setIsSettlePayoutModel] = useState(false);

  const [payoutCompletedItems, setPayoutCompletedItems] = useState([]);
  const [payoutCancelledItems, setPayoutCancelledItems] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceResponseData, setInvoiceResponseData] = useState(null);

  const [mainTabIndex, setMainTabIndex] = useState("1");

  const changeTabIndex = (index) => {
    setMainTabIndex(index);
  };

  const [permissionJson, setPermissionJson] = useState([]);
  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
      setPermissionJson(permissionJson);
    }
    if (!checkPermissionAction("Vendor Payouts", permissionJson, "view")) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handelSettlePayoutModelOk = () => {
    if (id) getPayoutDetail(id);
    setIsSettlePayoutModel(false);
  };
  const handelSettlePayoutModelCancel = () => {
    setIsSettlePayoutModel(false);
  };
  const getPayoutDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_VENDOR_PAYOUT.GET_VENDOR_PAYOUT_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        setPayoutData(data);
        if (data?.vendorPayoutItems && data?.vendorPayoutItems.length > 0) {
          let itemsCompletedData = [];
          let itemsCanclledData = [];
          for (let item of data?.vendorPayoutItems) {
            let productName = [];
            let vendorType = "";
            if (item?.itemsData)
              for (let name of item?.itemsData) {
                vendorType = name?.vendorType;
                if (name?.productLocales) {
                  for (let n of name?.productLocales) {
                    if (n.languageCode === "en") productName.push(n.name);
                  }
                } else productName.push("Custom Product");
              }
            let payoutData = {
              orderNumber: item?.orderNumber,
              productName: productName.length > 0 ? productName.join(",") : "",
              orderDeliveryDate: item?.order?.deliveryDate ? formatDateFunction(item?.order?.deliveryDate, "dd-mm-yyyy") : "",
              subTotal:
                vendorType === "host" ? item?.order?.priceDetails?.pickup_vendor_sub_total : item?.order?.priceDetails?.vendor_sub_total,
              vat: vendorType === "host" ? item?.order?.priceDetails?.pickup_vendor_vat : item?.order?.priceDetails?.vendor_vat,
              discount: vendorType === "host" ? 0 : item?.order?.priceDetails?.vendor_coupon_discount,
              distanceKM: item?.order?.priceDetails?.distanceKM,
              deliveryFee: item?.order?.priceDetails?.delivery_fees,
              plateformFee:
                vendorType === "host" ? item?.order?.priceDetails?.pickup_platform_fees : item?.order?.priceDetails?.vendor_platform_fees,
              deductions: item?.payoutJson?.deduction,
              payoutAmount: item?.payoutJson?.payoutAmount,
            };
            if (item.orderStatus === "cancelled") {
              itemsCanclledData.push(payoutData);
            } else {
              itemsCompletedData.push(payoutData);
            }
          }

          setPayoutCompletedItems(itemsCompletedData);
          setPayoutCancelledItems(itemsCanclledData);
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getPayoutDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportAllVednorPayout = async () => {
    // console.log(payoutCompletedItems); return false;
    dispatch(changeLoader(true));
    try {
      let exportData = [];
      for (let item of mainTabIndex === "1" ? payoutCompletedItems : payoutCancelledItems) {
        exportData.push({
          OrderId: item?.orderNumber,
          vendorName: payoutData?.user?.vendorDetail?.storeName,
          productName: item?.productName,
          orderDeliveryDate: item?.orderDeliveryDate,
          subTotalAmount: item?.subTotal,
          Vat: item?.vat,
          deliveryFee: item?.deliveryFee,
          distanceKM: item?.distanceKM,
          plateformFee: item?.plateformFee,
          deductions: item?.deductions,
          payoutAmount: item?.payoutAmount,
          status: mainTabIndex === "1" ? "Completed" : "Cancelled",
        });
      }

      const headers = Object.keys(exportData[0]).join(","); // Extract headers
      const rows = exportData.map((row) =>
        Object.values(row)
          .map((value) => `"${value}"`) // Escape values
          .join(",")
      );
      const csvContent = [headers, ...rows].join("\n");

      // Create a Blob and save file
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      saveAs(blob, "vendor_payout_orders.csv");
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const callGenerateInvoiceApi = async () => {
    let response = await globalRequest(
      `${Apis.MANAGE_VENDOR_PAYOUT.GENERATE_QUICKBOOKS_INVOICE}/${id}`,
      "post",
      {},
      {},
      true
    );
    return response?.data;
  };

  const sendQuickBooksInvoice = async () => {
    let popup = null;

    dispatch(changeLoader(true));
    try {
      let apiResponse = await callGenerateInvoiceApi();

      if (apiResponse?.data?.reauthRequired) {
        dispatch(changeLoader(false));

        popup = window.open("about:blank", "quickbooks_connect", "width=500,height=650");
        if (!popup) {
          toast.error("Please allow popups for this site to connect QuickBooks.");
          return;
        }

        toast("Please connect QuickBooks in the popup window to continue.", { icon: "🔗" });
        popup.location.href = apiResponse.data.authUrl;

        // Wait for the popup to report a successful connection.
        await waitForQuickBooksPopupResult(popup);

        dispatch(changeLoader(true));
        apiResponse = await callGenerateInvoiceApi();

        if (apiResponse?.data?.reauthRequired) {
          throw new Error("QuickBooks connection is still required. Please try again.");
        }
      }

      toast.success(apiResponse?.message);
      getPayoutDetail(id);
    } catch (e) {
      if (popup) popup.close();
      toast.error(e?.message || "Failed to generate QuickBooks invoice.");
    }
    dispatch(changeLoader(false));
  };

  const viewQuickBooksInvoice = () => {
    setInvoiceResponseData(payoutData?.quickbooksResponse || null);
    setShowInvoiceModal(true);
  };

  return (
    <>
      <Card>
        <div className="flex justify-between mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              <LeftOutlined className="mr-2" onClick={() => {
                sessionStorage.setItem('previousPath', location.pathname);
                navigate(-1)}} />
              Vendor Payouts Detail
            </Typography>
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">ID</th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap vertical-top">
                  Sales Period
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Vendor Name
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Expected Payout Date
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Actual Payout Date
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Expected Payout Amount
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Actual Payout Amount
                </th>
                <th scope="col" className="px-3 py-3 vertical-top">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b text-gray-700">
                <td className="px-3 py-4 vertical-top">{payoutData?.id}</td>
                <td className="px-3 py-4 vertical-top font-semibold cursor-pointer">
                  {formatDateFunction(payoutData?.peroidStartDate, "dd/mm/yyyy")} To{" "}
                  {formatDateFunction(payoutData?.peroidEndDate, "dd/mm/yyyy")}
                </td>
                <td className="px-3 py-4 vertical-top">
                  {payoutData?.user?.vendorDetail?.storeName}
                  {/* {payoutData?.user?.firstName} {payoutData?.user?.lastName} */}
                </td>
                <td className="px-3 py-4 vertical-top">{formatDateFunction(payoutData?.expectedPayoutDate, "dd/mm/yyyy")}</td>
                <td className="px-3 py-4 vertical-top">
                  {payoutData?.actualPayoutDate ? formatDateFunction(payoutData?.actualPayoutDate, "dd/mm/yyyy") : ""}
                </td>
                <td className="px-3 py-4 vertical-top">
                  { Number(payoutData?.expectedPayoutAmount).toFixed(2)}
                </td>
                <td className="px-3 py-4 vertical-top">
                  {Number(payoutData?.actualPayoutAmount) > 0 ? Number(payoutData?.actualPayoutAmount) : 0}
                </td>
                <td className="px-3 py-4 vertical-top">
                  <span
                    className={`flex items-center ${
                      payoutData.status === "planned" ? "bg-blue-50" : "bg-green-50"
                    } text-green-200 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]`}
                  >
                    {capitalizeName(payoutData?.status)}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="flex justify-between items-center my-5 gap-5">
            <div className="text-sm font-semibold">{payoutData?.payoutNotes ? `Note - ${payoutData?.payoutNotes}` : null}</div>
            <div className="text-sm font-semibold">
              {payoutData.status === "planned" ? (
                payoutData?.user?.vendorPayoutDetail ? (
                  <Button type="primary" size={14} className="mx-1.5 cursor-pointer" onClick={() => setIsSettlePayoutModel(true)}>
                    Mark as settled
                  </Button>
                ) : (
                  "This vendor does not have bank details."
                )
              ) : null}
              {checkPermissionAction("Vendor Payouts", permissionJson, "quickbooks_invoice") ? (
                payoutData?.quickbooksResponse ? (
                  <Button type="default" size={14} className="mx-1.5 cursor-pointer" onClick={viewQuickBooksInvoice}>
                    View Invoice
                  </Button>
                ) : (
                  <Button type="default" size={14} className="mx-1.5 cursor-pointer" onClick={sendQuickBooksInvoice}>
                    Generate Invoice
                  </Button>
                )
              ) : null}
              {checkPermissionAction("Vendor Payouts", permissionJson, "export") &&
              mainTabIndex === "1" &&
              payoutCompletedItems.length > 0 ? (
                <Button type="primary" size={14} className="mx-1.5 cursor-pointer" onClick={exportAllVednorPayout}>
                  Export
                </Button>
              ) : null}
              {checkPermissionAction("Vendor Payouts", permissionJson, "export") &&
              mainTabIndex === "2" &&
              payoutCancelledItems.length > 0 ? (
                <Button type="primary" size={14} className="mx-1.5 cursor-pointer" onClick={exportAllVednorPayout}>
                  Export
                </Button>
              ) : null}
            </div>
          </div>
          <Tabs activeKey={mainTabIndex} onChange={changeTabIndex}>
            <Tabs.TabPane tab={"Completed Order"} key={1}>
              <Orders items={payoutCompletedItems} />
            </Tabs.TabPane>
            <Tabs.TabPane tab={"Cancelled Order"} key={2}>
              <Orders items={payoutCancelledItems} />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Card>
      {/* <SettlePayout
        isOpen={isRefundOrderModel}
        onOk={handelRefundOrderModelOk}
        onCancel={handelRefundOrderModelCancel}
      /> */}
      {isSettlePayoutModel && (
        <SettlePayout
          isOpen={isSettlePayoutModel}
          onOk={handelSettlePayoutModelOk}
          onCancel={handelSettlePayoutModelCancel}
          type={"vendor"}
          payoutData={payoutData}
        />
      )}
      <Modal
        title="QuickBooks Invoice Response"
        open={showInvoiceModal}
        onOk={() => setShowInvoiceModal(false)}
        onCancel={() => setShowInvoiceModal(false)}
        width={800}
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto", padding: 16 }}
      >
        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <pre className="whitespace-pre-wrap break-words text-xs">
            {invoiceResponseData ? JSON.stringify(invoiceResponseData, null, 2) : "No invoice response available."}
          </pre>
        </div>
      </Modal>
    </>
  );
};
export default VendorPayoutsDetail;
